import { render } from "./FormCreateOrUpdate.vue?vue&type=template&id=7c72f99c&scoped=true"
import script from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"

import "./FormCreateOrUpdate.vue?vue&type=style&index=0&id=7c72f99c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c72f99c"

export default script